<section
  class="disclaimer-section container-fluid sts-section sts-form">

  <app-sts-section-header key="sts-disclaimer-header" [errors]="errors">Terms of
    use
  </app-sts-section-header>

  <app-sts-section-body key="sts-disclaimer-instruction"
      (renderingComplete)="instructionLoaded($event)">
    <div class="col-24">To complete your registration, please read and accept
      the Terms of Use.
    </div>
  </app-sts-section-body>

  <form (ngSubmit)="onSave()" class="sts-form" autocomplete="off">

    <div class="row sts-form-row ">
      <div class="col-24">

        <div class="container-fluid">

          <div class="row">

            <div class="col-24 spaced-bottom">

              <input type="checkbox" class="sts-checkbox" (change)="addProp1($event)">

              <span app-sts-cms-txt key="sts-disclaimer-body"
                    (renderingComplete)="bodyLoaded($event)">
                <a href="#"
                    (click)="click(termsLink)">Terms of use</a>
                and
                <a href="#" class="ariel-sts-iframe"
                    data-src="/Article/Print/privacy-guidelines">
                  Privacy policy
                </a>
              </span>

            </div>

          </div>


        </div>

      </div>
    </div>

    <div class="row">
      <div class="col-24">
        <button app-sts-cms-txt key="sts-cancel-button"
              class="sts-btn other-sts-btn" type="button"
              (click)="onCancel()">
          Cancel
        </button>
        <app-sts-button key="sts-save" *ngIf="!formSubmitSuccess">
          Save
        </app-sts-button>
        <app-sts-button key="sts-continue"
                        [disabled]="!isAgreed"
                        buttonType="button"
                        *ngIf="formSubmitSuccess" (click)="onContinue()"
                        #continueBtnRef="app-sts-button">
          Continue
        </app-sts-button>

      </div>
    </div>

    <app-sts-bs-dialog [(visible)]="showDialog" [(item)]="dialogueItem">
      <iframe [src]="getCurrentLink() | stsSafeUrl" width="100%" class="dialog-iframe" frameborder="0"></iframe>
    </app-sts-bs-dialog>


  </form>


</section>
